import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hockey-right',
  templateUrl: './hockey-right.component.html',
  styleUrls: ['./hockey-right.component.scss']
})
export class HockeyRightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
